import { render } from "./MemberPhotoModal.vue?vue&type=template&id=72abfb06&scoped=true"
import script from "./MemberPhotoModal.vue?vue&type=script&lang=js"
export * from "./MemberPhotoModal.vue?vue&type=script&lang=js"

import "./MemberPhotoModal.vue?vue&type=style&index=0&id=72abfb06&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72abfb06"]])

export default __exports__